import { useTranslation } from "react-i18next";
import { CircleX as CloseIcon, RotateCcw as ReopenIcon } from "lucide-react";
import type { ConversationStatusName } from "@multi-chat/shared";
import { Button } from "../../components/ui/button/index.js";

export function isWorkflowClosed(status: ConversationStatusName): boolean {
  return status === "CLOSED" || status === "ARCHIVED";
}

export function ConversationStatusControl({
  status,
  pending,
  onSetStatus,
}: {
  status: ConversationStatusName;
  pending: boolean;
  onSetStatus: (status: "OPEN" | "CLOSED") => void;
}): React.JSX.Element {
  const { t } = useTranslation();
  const closed = isWorkflowClosed(status);
  return (
    <Button
      type="button"
      variant="outline"
      size="sm"
      disabled={pending}
      className="h-8 rounded-[9px] px-2.5 text-[0.8125rem]"
      data-testid={closed ? "inbox-reopen" : "inbox-close"}
      onClick={() => onSetStatus(closed ? "OPEN" : "CLOSED")}
    >
      {closed ? <ReopenIcon size={16} aria-hidden="true" /> : <CloseIcon size={16} aria-hidden="true" />}
      {closed ? t("inbox.workflow.status.reopen") : t("inbox.workflow.status.close")}
    </Button>
  );
}
